import gql from "graphql-tag";
import { technicianQueryReturnFields } from "../queries/getTechnician";

export const CREATE_TECHNICIAN = gql`mutation createTechnician($createTechnicianInput: CreateTechnicianInput!) {
    createTechnician(createTechnicianInput: $createTechnicianInput) {
        ${technicianQueryReturnFields}
    }
}`;
